import { defineElement, injectView } from "domvm";
import { isObject, isString } from "../../data/utils.js";
import numeral from "numeral";
import { Services } from "../../services/Services.js";
import * as dom from "../../utils/dom.js";

const el = defineElement;

// --------------------------------------------------------------------------------------------

function grid(css, props, cols) {

    return _render('.grid', _args(css, props, cols));

};

function hrow(css, props, cols) {

    return _render('.row', _args(css, props, cols));

};

function vrow(css, props, cols) {

    return _render('.row.vertical', _args(css, props, cols));

};

function cell(css, props, controls) {

    return _render('div', _args(css, props, controls));

};

function autocell(css, props, controls) {

    return _render('div.shrink', _args(css, props, controls));

};

// --------------------------------------------------------------------------------------------

function hstrip(css, props, cells) {

    return _render('.strip', _args(css, props, cells));

};

function vstrip(css, props, cells) {

    return _render('.strip.vertical', _args(css, props, cells));

};

function slice(css, props, controls) {

    return _render('.slice', _args(css, props, controls));

};


// ============================================================================================
// Elements
// ============================================================================================

function div(css, props, controls, options) {

    return _render('div', _args(css, props, controls, options));

};

function p(css, props, controls, options) {

    return _render('p', _args(css, props, controls, options));

};

function span(css, props, controls, options) {

    return _render('span', _args(css, props, controls, options));

};

function link(href, css, props, controls, options) {

    let args = _args(css, props, controls, options);

    args.props.href = href;

    return _render('a', args);

};

function space(css, props) {

    return _render('.space', _args(css, props));

};

// -------------------------------------------------------------------------------------------- Self closing tags

function br(css, props, options) {

    return _render('br', _args(css, props, options));

};

function hr(css, props, options) {

    return _render('hr', _args(css, props, options));

};

function img(css, props, options) {

    return _render('img.image', _args(css, props, options));

};

// -------------------------------------------------------------------------------------------- Headings

// Display headings

function d1(css, props, controls, options) {
    return _render('h1', _args(css, props, controls, options));
};

function d2(css, props, controls, options) {
    return _render('h2', _args(css, props, controls, options));
};

function d3(css, props, controls, options) {
    return _render('h3', _args(css, props, controls, options));
};

// Headings

function h1(css, props, controls, options) {
    return _render('h4', _args(css, props, controls, options));
};

function h2(css, props, controls, options) {
    return _render('h5', _args(css, props, controls, options));
};

function h3(css, props, controls, options) {
    return _render('h6', _args(css, props, controls, options));
};

// ============================================================================================ 
// Lists
// ============================================================================================ 

// -------------------------------------------------------------------------------------------- Table

function list(css, props, cells, options) {

    const args = _args(css, props, cells, options);

    args.controls = args.controls.reduce((controls, item) => {
        if (item !== null && item !== undefined) {
            controls.push(el('li', [item]));
        }
        return controls;
    }, []);

    return _render('ul.list', args);

};


// ============================================================================================ 
// Tables
// ============================================================================================ 

// -------------------------------------------------------------------------------------------- Table

function table(css, props, cells) {

    return _render('table.table', _args(css, props, cells));

};

function thead(css, props, cells) {

    return _render('thead', _args(css, props, cells));

};

function tbody(css, props, cells) {

    return _render('tbody', _args(css, props, cells));

};

function tfoot(css, props, cells) {

    return _render('tfoot', _args(css, props, cells));

};

function trow(css, props, cells) {

    return _render('tr', _args(css, props, cells));

};

function tcell(css, props, controls) {

    return _render('td', _args(css, props, controls));

};

function thcell(css, props, controls) {

    return _render('th', _args(css, props, controls));

};

// -------------------------------------------------------------------------------------------- Lists

function ulist(css, props, items, options) { return _render('ul', _args(css, props, items, options)); }
function olist(css, props, items, options) { return _render('ol', _args(css, props, items, options)); }
function litem(css, props, items, options) { return _render('li', _args(css, props, items, options)); }

// --------------------------------------------------------------------------------------------

function tabs(css, props, tabs) {

    return _render('nav.tabs', _args(css, props, tabs));

};

function tab(active, css, props, controls) {

    const args = _args(css, props, controls);

    args.css += (active ? '.active' : '');

    return _render('a', args);

};

// --------------------------------------------------------------------------------------------

function labeledControl(name, label, css, props, controls, options) {

    const args = _args(css, props, controls, options);

    props = props || {};

    if (props.visible !== undefined && !props.visible)
        return null;

    let renderProps = createRenderProps({}, props);
    delete renderProps.controlName;

    css = css || '';

    return el('.form-group' + css, renderProps, [
        el('label', { for: props.controlName }, label),
        control
    ]);

};

// ============================================================================================
//  Containers
// ============================================================================================

// -------------------------------------------------------------------------------------------- Container

function app(css, props, controls) {

    return _render('#app', _args(css, props, controls));

};

function main(css, props, controls) {

    return _render('main', _args(css, props, controls));

};

function header(css, props, controls) {

    return _render('header', _args(css, props, controls));

};

function footer(css, props, controls) {

    return _render('footer', _args(css, props, controls));

};

function module(css, props, controls) {

    return _render('main', _args(css, props, controls));

};

function section(css, props, controls) {

    return _render('section', _args(css, props, controls));

};

function container(css, props, controls) {

    return _render('.container', _args(css, props, controls));

};

function panel(css, props, controls) {

    return _render('article', _args(css, props, controls));

};

function overlay(css, props, controls) {

    return _render('.overlay', _args(css, props, controls));

};

function dialog(css, props, controls) {

    return _render('dialog', _args(css, props, controls));

};

// -------------------------------------------------------------------------------------------- Card

function card(css, props, controls) {

    return _render('article', _args(css, props, controls));

};

function cardHead(css, props, controls) {

    return _render('.card-header', _args(css, props, controls));

};

function cardImg(css, props, controls) {

    return _render('.card-image', _args(css, props, controls));

};

function cardTitle(css, props, controls) {

    return _render('.card-title', _args(css, props, controls));

};

function cardBody(css, props, controls) {

    return _render('.card-body', _args(css, props, controls));

};

function cardFoot(css, props, controls) {

    return _render('.card-footer', _args(css, props, controls));

};

// --------------------------------------------------------------------------------------------

const _cursorsMap = {
    'hand': '.c-hand',
    'move': '.c-move',
    'zoom-in': '.c-zoom-in',
    'zoom-out': '.c-zoom-out',
    'not-allowed': '.c-not-allowed',
};

function getCursorStyle(name) {
    return (_cursorsMap[name] || '');
};

// ============================================================================================ 
// Icons
// ============================================================================================ 

const _iconsMap = {
    'refresh': '.fa-sync',
    'recalc': '.fa-calculator',
    //
    'show': '.fa-eye',
    'open': '.fa-arrow-up-right-from-square',
    'open-in-new': '.fa-arrow-up-right-from-square',
    'close': '.fa-times',
    'back': '.fa-arrow-left',
    //
    'add': '.fa-plus',
    'create': '.fa-plus',
    'edit': '.fa-pen',
    'delete': '.fa-trash-alt',
    'filter': '.fa-filter',
    'lock': '.fa-lock-alt',
    'unlock': '.fa-lock-open-alt',
    'preview': '.fa-eye',
    // 
    'confirm': '.fa-check',
    'cancel': '.fa-times',
    // 
    'insert': '.fa-plus-circle',
    'remove': '.fa-minus-circle',
    'clear': '.fa-eraser',
    'move-up': '.fa-chevron-circle-up',
    'move-down': '.fa-chevron-circle-down',
    'move-left': '.fa-chevron-circle-left',
    'move-right': '.fa-chevron-circle-right',
    //
    'chevron-up': '.fa-chevron-up',
    'chevron-down': '.fa-chevron-down',
    'chevron-left': '.fa-chevron-left',
    'chevron-right': '.fa-chevron-right',
    //
    'arrow-up': '.fa-arrow-up',
    'arrow-down': '.fa-arrow-down',
    'arrow-left': '.fa-arrow-left',
    'arrow-right': '.fa-arrow-right',
    //
    'expand': '.fa-angle-down',
    'collapse': '.fa-angle-up',
    //
    'toggle-on': '.fa-caret-down',
    'toggle-off': '.fa-caret-up',
    //
    'checked': '.fa-square-check',
    'unchecked': '.fa-square',
    //
    'upload': '.fa-upload',
    'download': '.fa-download',
    //
    'file': '.fa-file',
    'file-add': '.fa-file-plus',
    'file-delete': '.fa-file-minus',
    'file-edit': '.fa-file-edit',
    'file-image': '.fa-file-image',
    'file-audio': '.fa-file-audio',
    'file-video': '.fa-file-video',
    'file-archive': '.fa-file-archive',
    'file-code': '.fa-file-code',
    'file-csv': '.fa-file-csv',
    'file-pdf': '.fa-file-pdf',
    'file-word': '.fa-file-word',
    'file-excel': '.fa-file-excel',
    'file-powerpoint': '.fa-file-powerpoint',
    //
    'folder': '.fa-folder',
    'folder-outline': '.fa-folder.text-secondary',
    'folder-open': '.fa-folder-open',
    'folder-add': '.fa-folder-plus',
    'folder-up': '.fa-folder-upload',
    //
    'home': '.fa-home',
    'next': '.fa-chevron-right',
    'prior': '.fa-chevron-left',
    //
    'user': '.fa-user',
    'account': '.fa-user',
    'login': '.fa-arrow-right-to-bracket',
    'logout': '.fa-arrow-right-from-bracket',
    //
    'play': '.fa-play',
    'stop': '.fa-stop',
    'pause': '.fa-pause',
    'backward': '.fa-angle-left',
    'fast-backward': '.fa-angle-double-left',
    'forward': '.fa-angle-right',
    'fast-forward': '.fa-angle-double-right',
    //
    'sort': '.fa-arrow-down-arrow-up',
    'sort-up': '.fa-arrow-up',
    'sort-down': '.fa-arrow-down',
    //
    'layout-table': '.fa-th-list',
    'layout-thumbnails': '.fa-th-large',
    //
    'zoom-in': '.fa-search-plus',
    'zoom-out': '.fa-search-minus',
    //
    'screen-expand': '.fa-expand',
    'screen-collapse': '.fa-compress',
    //
    'info': '.fa-info-circle',
    'calendar': '.fa-calendar-alt',
    'calendar-day': '.fa-calendar-day',
    'calendar-week': '.fa-calendar-week',
    'spinner': '.fa-spinner.fa-spin-pulse',
    //
    'chart': '.fa-chart-line',
    'chart-line': '.fa-chart-line',
    'chart-pie': '.fa-chart-pie',
    'chart-bar': '.fa-chart-bar',
    'chart-area': '.fa-chart-area',
    'chart-scatter': '.fa-chart-scatter',
    //
    'table': '.fa-table',
    'eye': '.fa-eye',
    'cog': '.fa-cog',
    'cogs': '.fa-cogs',
    'book': '.fa-book',
    'books': '.fa-books',
    'attachment': '.fa-paperclip',
};

const _iconSizeMap = {
    'tiny': '.fa-xs',
    'small': '.fa-sm',
    'large': '.fa-lg',
    'huge': '.fa-xl',
    'xxs': '.fa-2xs',
    'xs': '.fa-xs',
    'sm': '.fa-sm',
    'lg': '.fa-lg',
    'xl': '.fa-xl',
    'xxl': '.fa-2xl',
    '1x': '.fa-1x',
    '2x': '.fa-2x',
    '3x': '.fa-3x',
    '4x': '.fa-4x',
    '5x': '.fa-5x',
    '6x': '.fa-6x',
    '7x': '.fa-7x',
    '8x': '.fa-8x',
    '9x': '.fa-9x',
    '10x': '.fa-10x',
};

const _iconAnimationMap = {
    'beat': '.fa-beat',
    'spin': '.fa-spin',
    'pulse': '.fa-spin-pulse',
    'bounce': '.fa-bounce',
    'flip': '.fa-flip',
};

const _iconTransformationMap = {
    'rotate-90': '.fa-rotate-90',
    'rotate-180': '.fa-rotate-180',
    'rotate-270': '.fa-spin-rotate-270',
    'flip-horizontal': '.fa-flip-horizontal',
    'flip-vertical': '.fa-flip-vertical',
    'flip-both': '.fa-flip-both',
};

function icon(name, css, props, options) {

    name = '.fa-regular' + (_iconsMap[name] || `.fa-${name}`);

    let args = _args(css, props, options);

    if (args.options.size)
        args.css += _iconSizeMap[args.options.size] || '';
    // animation excludes transformation    
    if (args.options.animation)
        args.css += _iconAnimationMap[args.options.animation] || '';
    else if (args.options.transformation)
        args.css += _iconTransformationMap[args.options.transformation] || '';

    return _render(`i.${name}`, args);

};

// --------------------------------------------------------------------------------------------

function hintIcon(text) {

    return el('sup', [
        el('i.fa-info-circle', { title: text })
    ]);

};

// --------------------------------------------------------------------------------------------

function tag(tag, css, props, controls, options) {

    return _render(tag, _args(css, props, controls, options));

};

// ============================================================================================ 
// Forms
// ============================================================================================ 

function group(css, props, controls) {

    return _render('.group', _args(css, props, controls));

};

// alias
//formGroup = group;

// -------------------------------------------------------------------------------------------- Buttons

// #region Buttons

function customButton(css, props, controls, options) {

    let args = _args(css, props, controls, options);
    args.props.type ||= 'button';
    return _render('button', args);

};

function button(label, iconName, css, props, controls, options) {

    let args = _args(css, props, controls, options);
    args.props.type ||= 'button';
    if (label)
        args.controls.unshift(label);
    if (iconName)
        args.controls.unshift(icon(iconName));
    return _render('button', args);

};

function textButton(text, css, props, controls, options) {

    return button(text, null, css, props, controls, options);

};

function iconButton(iconName, css, props, controls, options) {

    return button(null, iconName, css, props, controls, options);

};

function expandButton(expanded, css, props, controls, options) {

    return iconButton(expanded ? 'collapse-item' : 'expand-item', css, props, controls, options);

};

function uploadButton(label, iconName, css, props, controls, options) {

    const args = _args(css, props, controls, options);

    const onclick = args.props.onclick;
    const multiple = !!args.options.multiple;
    const accept = args.options.accept || '';

    args.props.onclick = async (e) => {
        const files = await pickFiles({ multiple, accept });
        if (onclick) {
            e.files = files;
            onclick(e);
        }
    };

    return button(label, iconName, args.css, args.props, args.controls);

}

function pickFiles({ multiple = false, accept = '' } = {}) {

    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = multiple;
        input.accept = accept;

        input.addEventListener('change', () => {
            if (!input.files.length) {
                reject('cancelled');
                return;
            }

            resolve(Array.from(input.files));
        });

        input.click();
    });

}

function buttonArray(buttonDefs, filter) {

    filter = filter || function (buttonDef) { return true; };

    return (buttonDefs || []).reduce(function (result, buttonDef, index) {

        if (!filter(buttonDef))
            return result;

        let label = buttonDef.label,
            iconName = buttonDef.icon,
            css = buttonDef.css,
            props = buttonDef.props || {
                onclick: buttonDef.handler
            },
            options = {
                primary: buttonDef.primary,
                appearance: buttonDef.type,
            };

        if (index > 0)
            result.push(' ');
        result.push(button(label, iconName, css, props, options));

        return result;

    }, []);

};


// #endregion

// -------------------------------------------------------------------------------------------- Text

// #region Text

function label(text, css, props, controls, options) {

    let args = _args(css, props, controls, options);

    args.controls = args.controls.length ? [text].concat(args.controls) : [text];

    return _render('label', args);

};

function textBox(value, css, props, options) {

    if (!css && props && options)
        css = '';

    let args = _args(css, props, options);

    if (args.props.visible === false)
        return null;

    args.props.value = value;
    args.props.type ||= 'text';

    return _render('input.form-input', args);

};

function textArea(value, css, props, options) {

    let args = _args(css, props, options);

    if (args.props.visible === false)
        return null;

    args.props.value = value;
    args.props.rows = args.props.rows || args.options.rows || 10;

    return _render('textArea.form-input', args);

};

function textAreaEx(value, css, props, options) {

    let args = _args(css, props, options);

    if (args.props.visible === false)
        return null;

    let areaProps = args.props;
    areaProps.rows = args.options.expanded ? (args.options.maxRows || 15) : (args.options.minRows || 3);

    args.props = {};

    args.controls = [
        button(
            { onclick: args.options.ontoggleclick },
            [icon(args.options.expanded ? 'collapse-item' : 'expand-item')]
        ),
        textArea(value, areaProps)
    ];

    return _render('.group', args);

};

function numBox(value, format, css, props, options) {

    let args = _args(css, props, options);

    if (args.options.visible === false)
        return null;

    args.props.value = (value === undefined || value === null || value === false) ? null : numeral(value).format(format);
    args.props.type ||= 'text';

    return _render('input.form-input', args);

};

// #endregion

// -------------------------------------------------------------------------------------------- Checkbox

function checkBox(value, label, css, props, options) {

    let args = _args(css, props, options);

    if (args.options.visible === false)
        return null;

    args.props.checked = value;
    args.props.type = 'checkBox';

    let controls = [el('input', args.props)];
    if (label)
        controls.push(el('span', [label]));

    return el('label.checkBox' + args.css, { for: args.props.id }, controls);

};

// -------------------------------------------------------------------------------------------- Radiobox

function radioBox(value, label, css, props, options) {

    let args = _args(css, props, options);

    if (args.options.visible === false)
        return null;

    args.props.checked = value;
    args.props.type = 'radio';

    let controls = [el('input', args.props)];
    if (label)
        controls.push(el('span', [label]));

    return el('label.radioBox' + args.css, { for: args.props.id }, controls);

};

// -------------------------------------------------------------------------------------------- Combobox

function comboBox(value, items, css, props, options) {

    let args = _args(css, props, options);

    let emptyLabel = args.options.emptyOptionLabel ?? null,
        emptyValue = dom.normalizeOptionValue(args.options.emptyOptionValue);

    if (emptyLabel)
        args.controls.push(el('option', { value: emptyValue, selected: (emptyValue == value) }, [emptyLabel]));

    items.forEach((item) => {
        let itemValue = dom.normalizeOptionValue(item.value);
        args.controls.push(
            el('option', { value: itemValue, selected: (itemValue == value), _data: item.data }, [item.label])
        );
    });

    return _render('select', args);

};

// --------------------------------------------------------------------------------------------

function field(css, props, controls, options) {

    return _render('.field', _args(css, props, controls, options));

};

// -------------------------------------------------------------------------------------------- Errors

function inputHint(hint) {

    if (!hint)
        return null;

    return span([hint]);

};

function inputError(error) {

    if (!error)
        return null;

    return span('.error-text', [error]);

};

// -------------------------------------------------------------------------------------------- Menu

function menu(css, props, controls, options) {

    let args = _args(css, props, controls, options);
    return _render('menu', args);

};

function dropdownMenu(css, props, controls, options) {

    let args = _args(css, props, controls, options);
    return _render('menu.dropdown', args);

};

function menuItem(css, props, controls, options) {

    return _render('li', _args(css, props, controls, options));

};

function menuDivider(text = null) {

    let props = {};

    if (text)
        props['data-content'] = text;

    return el('.divider', props);

};

// -------------------------------------------------------------------------------------------- dropdown button

/**
 * 
 * @param {*} label 
 * @param {*} iconName 
 * @param {*} css 
 * @param {*} props 
 * @param {array} menu Menu control wrapped in array.
 * @param {*} options 
 * @returns 
 */

function dropdownButton(label, iconName, css, props, menu, options) {

    let args = _args(css, props, menu, options);

    let buttonArgs = __args(args.css, args.props);

    if (label)
        buttonArgs.controls.push(label);

    buttonArgs.controls.push(icon(iconName || 'carret-down'));
    buttonArgs.controls = buttonArgs.controls.concat(args.controls);
    buttonArgs.props.onclick = (e) => {

        let button = e.target;

        while (button != null && button.nodeName != 'BUTTON') {
            button = button.parentNode;
        }

        if (!button)
            return;

        let node = button.firstChild,
            menu = null;

        while (node != null) {
            if (node.nodeName == 'MENU') {
                menu = node;
                break;
            }
            node = node.nextSibling;
        }

        if (menu == null)
            return;

        const outsideClickListener = (event) => {
            if (!menu.contains(event.target)) {
                menu.classList.remove('active');
                document.removeEventListener('click', outsideClickListener);
            }
        };

        if (menu.classList.contains('active')) {
            menu.classList.remove('active');
            document.removeEventListener('click', outsideClickListener);
            return;
        }

        e.stopPropagation();

        menu.classList.add('active');

        // malý timeout zabrání tomu, aby se handler ihned spustil při stejném kliknutí
        setTimeout(() => {
            document.addEventListener('click', outsideClickListener);
        }, 0);

    };

    return _render('button', buttonArgs);

};

// -------------------------------------------------------------------------------------------- nav

function nav(css, props, controls, options) {

    return _render('nav', _args(css, props, controls, options));

};

function navgap(css) {

    return _render('.max', _args(css));

};

// -------------------------------------------------------------------------------------------- navbar

function navbar(css, props, controls, options) {

    return _render('header.navbar', _args(css, props, controls, options));

};

function navbarSection(css, props, controls, options) {

    return _render('section.navbar-section', _args(css, props, controls, options));

};

function navbarBrand(css, props, controls, options) {

    return _render('a.navbar-brand', _args(css, props, controls, options));

};

// -------------------------------------------------------------------------------------------- Pagination

// #region Pagination

/**
 * 
 * @param {string} path Enpoint path.
 * @param {array} queryParams Actual query params.
 * @param {int} count Dataset records count.
 * @param {int} offset Dataset records offset.
 * @param {int} limit Dataset records limit.
 * @param {function(e)} eventHandler Event handler.
 * @param {string} css 
 * @param {object} props 
 * @param {object} options 
 * @returns 
 */
function paginatorOffset(count, offset, limit, eventHandler, css, props, options) {

    const args = _args(css, props, options);

    if (args.options.visible === false)
        return null;

    offset ||= 0;
    const config = Services.get('config');
    limit ||= (config.paginator && config.paginator.defaultPageSize) || 25;
    count ||= 0;

    let pgCount = Math.ceil(count / limit);

    if (pgCount <= 1)
        return null;

    let pgIndex = Math.floor(offset / limit);

    if (pgIndex >= pgCount)
        pgIndex = pgCount - 1;
    if (pgIndex < 0)
        pgIndex = 0;

    let visiblePages = [];

    if (pgCount <= 7) {
        visiblePages = Array.from({ length: pgCount }, (_, index) => index);
    } else if (pgIndex <= 3) {
        visiblePages = [0, 1, 2, 3, 4, 5, 6];
    } else if (pgIndex >= (pgCount - 6)) {
        visiblePages = Array.from({ length: 7 }, (_, index) => (pgCount - 7) + index);
    } else {
        visiblePages = [pgIndex - 1, pgIndex, pgIndex + 1, pgIndex + 2, pgIndex + 3];
    }

    let items = [
        iconButton('chevron-left', '.outlined', {
            disabled: (pgIndex <= 0),
            onclick: () => { eventHandler({ offset: (pgIndex - 1) * limit }); }
        })
    ];

    const firstVisible = visiblePages[0];
    const lastVisible = visiblePages[visiblePages.length - 1];

    if (firstVisible > 0) {
        items.push(createPageButton(0));
        if (firstVisible > 1)
            items.push(createEllipsis());
    }

    visiblePages.forEach((pageIndex) => {
        items.push(createPageButton(pageIndex));
    });

    if (lastVisible < (pgCount - 1)) {
        if (lastVisible < (pgCount - 2))
            items.push(createEllipsis());
        items.push(createPageButton(pgCount - 1));
    }

    items.push(
        iconButton('chevron-right', '.outlined', {
            disabled: (pgIndex >= (pgCount - 1)),
            onclick: () => { eventHandler({ offset: (pgIndex + 1) * limit }); }
        })
    );

    return group(args.css, args.props, items);

    function createPageButton(pageIndex) {

        return textButton((pageIndex + 1).toString(), '.outlined' + (pageIndex == pgIndex ? '.active' : ''), {
            //disabled: (pageIndex == pgIndex),
            onclick: () => { eventHandler({ offset: pageIndex * limit }); }
        });

    }

    function createEllipsis() {

        return textButton('...', '.outlined', { disabled: true });

    }

};

function paginatorLimit(limit, eventHandler, css, props, options) {

    const args = _args(css, props, options);

    if (args.options.visible === false)
        return null;

    const config = Services.get('config');
    const cfg = config.paginator || {};

    let sizes = cfg.availablePageSizes || [10, 25, 50, 100];

    limit ||= cfg.defaultPageSize || 25;

    let selectProps = Object.assign({}, args.props);

    selectProps.onchange = (ev) => {

        let value = parseInt(dom.getSelectValue(ev));

        if (!isNaN(value))
            eventHandler({ limit: value });

        if (args.props.onchange)
            args.props.onchange(ev);

    };

    return el('select' + args.css, selectProps, sizes.map((size) => {
        return el('option', { value: size, selected: limit == size }, [
            size
        ]);
    }));

};

// #endregion

// -------------------------------------------------------------------------------------------- Toast

// #region Toast

function toast(css, props, controls) {

    const args = _args(css, props, controls);

    return _render('div.toast', args);

};

// #endregion

// -------------------------------------------------------------------------------------------- Empty

// #region Empty

/**
 * 
 * @param {string} title - displayed text
 * @param {string} subtitle - second line of text
 * @param {array} content - array of action buttons
 * @param {object} options - additional parameters 
 * @param {string} options.type - error | warning | success | info | default
 * @returns 
 */
function empty(options, controls) {

    if (!options)
        return null;
    if (options.visible === false)
        return null;

    let css = '.middle-align.center-align',
        props = {},
        content = [space()];

    if (options.css)
        css += options.css;

    switch (options.type) {
        case 'error':
            css += '.error';
            break;
        case 'warning':
            css += '.warning';
            break;
        case 'success':
            css += '.success';
            break;
        case 'info':
            css += '.secondary';
            break;
    }

    if (options.icon) {
        content.push(space());
        if (isObject(options.icon)) {
            content.push(options.icon);
        } else if (isString(options.icon)) {
            content.push(icon(options.icon));
        } else {
            throw new Error('Unexpected icon format');
        }
    }

    if (options.title) {
        content.push(h1([options.title]));
    }

    if (options.subtitle) {
        content.push(space());
        content.push(p([options.subtitle]));
    }

    if (controls) {
        content.push(nav('.center-align', controls))
    }

    content.push(space());

    return card(css, props, [
        section(content)
    ]);

};

// #endregion

// -------------------------------------------------------------------------------------------- IFrame

// #region IFrame

function iframe(css, props, options) {

    let def = _args('iframe', css, props, options);

    if (def.props.visible === false)
        return null;

    switch (def.options.size) {
        case 'small':
            def.css += '.small';
            break;
        case 'large':
            def.css += '.large';
            break;
        default:
            def.css += '.medium';
            break;
    }

    if (def.options.resizable) {

        return el('.p-relative', [
            el(def.tag + def.css, def.props),
            grid([
                cell([]),
                autocell([
                    button({ onclick: [onResizeClick, 'small'] }, [icon('square-small')], { active: def.options.size == 'small' }),
                    ' ',
                    button({ onclick: [onResizeClick, 'medium'] }, [icon('square')], { active: def.options.size == 'medium' }),
                    ' ',
                    button({ onclick: [onResizeClick, 'large'] }, [icon('square-full')], { active: def.options.size == 'large' }),
                    ' ',
                    button({ onclick: onFullscreenClick }, [icon('expand')]),
                ]),
            ])
        ]);

    }

    return el(def.tag + def.css, def.props);

    function onResizeClick(size, e) {

        if (!def.options.onresizeclick)
            return;
        def.options.onresizeclick(size);

    };

    function onFullscreenClick(e) {

        let element = document.getElementById(def.props.id);
        if (!element)
            return;
        if (!document.fullscreenElement) {
            element.requestFullscreen();
        }

    };

};

// #endregion

// -------------------------------------------------------------------------------------------- Breadcrumbs

// #region Breadcrumbs

/**
 * 
 * @param {string} css 
 * @param {object} props 
 * @param {array} items Array of DomVM nodes.
 * @param {object} options 
 * @returns {object} DomVM node.
 */
function breadcrumbs(css, props, items, options) {

    let args = _args(css, props, items, options)

    if (args.options.visible === false)
        return null;

    args.controls = args.controls.map((control) => {
        return el('li.breadcrumb-item.c-hand', [
            control
        ]);
    });

    return _render('ul.breadcrumb', args);

};

// #endregion

// ============================================================================================ 
// Utils
// ============================================================================================ 

// #region Utils

function concat(controls) {

    if (!controls)
        return [];
    if (!Array.isArray(controls))
        controls = [controls];
    return controls.reduce((result, item) => result.concat(item), []);

};

/**
 * Renders CSS classes for responsive width of element.
 * @param {number|auto|shrink} s Number of width columns.
 * @param {number} m Number of width columns.
 * @param {number} l Number of width columns.
 * @returns {string}
 */
function width(s, m = null, l = null) {

    if (s === undefined || s === null)
        return '';

    switch (s) {
        case 'max':
        case 'auto':
            return '.max';
        case 'min':
        case 'shrink':
            return '.min';
    }

    return processSegment('s', s) + processSegment('m', m) + processSegment('l', l);

    function processSegment(prefix, value) {

        if (value === undefined)
            return '';
        if (value === null)
            return '';

        if (value == 'min' || value == 'shrink')
            return `.${prefix}-min`;
        if (value == 'max' || value == 'auto')
            return `.${prefix}-max`;

        let w = parseInt(value);
        if (isNaN(w)) throw new Error('Number required');
        if (w <= 0)
            return '';

        return `.${prefix}${w}`;

    };

};

function widthFixed(width) {

    return width(width, true);

};

function cellWidth(width, fixed) {

    if (width === undefined || width === null)
        return '';
    if (width === 'auto')
        return '';
    if (width === 'shrink')
        return '.shrink';
    return this.width(width, fixed);

};

function cellWidthFixed(width) {

    return this.cellWidth(width, true);

};

// #endregion

// ============================================================================================ 
// Helpers
// ============================================================================================ 

// #region Helpers

const isArr = Array.isArray;

function isObj(val) {
    return val != null && val.constructor === Object;		//  && typeof val === "object"
}

function isStr(val) {
    let t = typeof val;
    return t === 'string';
}

function isVal(val) {
    let t = typeof val;
    return t === 'string' || t === 'number';
}

function isFunc(val) {
    return typeof val === 'function';
}

// #endregion

// -------------------------------------------------------------------------------------------- Args & Rendering

// #region Args & Rendering


function __args(css = '', props = {}, controls = [], options = {}) {

    return { css, props, controls, options };

};

/**
 * @param {string} arg1 - css 
 * @param {object} arg2 - props
 * @param {array} arg3 - controls
 * @param {object} arg4 - options
 * @returns 
 */
function _args(/* arg1, arg2, arg3, arg4 */) {

    let args = arguments;

    let def = __args();

    let index = 0;
    let arg = null;

    if (!next())
        return def;
    if (isStr(arg)) {
        def.css = arg;
        if (!next()) return def;
    }
    if (isObj(arg)) {
        def.props = arg;
        if (!next()) return def;
    }
    if (isArr(arg)) {
        def.controls = arg;
        if (!next()) return def;
    }
    if (isObj(arg)) {
        def.options = arg;
    }

    return def;

    function next() {
        arg = args[index];
        index++;
        return arg !== undefined;
        //return index < args.length;
    }

};

function _render(tag, args) {

    if (!tag || tag === '')
        throw new Error('Parameter "tag" is required.');
    if (!args)
        throw new Error('Parameter "args" is required.');

    if (args.props.visible === false)
        return null;

    return el(tag + args.css, args.props, args.controls);

};

function createRenderProps(template, values, hooksRequired) {

    template = template || {};
    values = values || {};

    let renderProps = Object.assign(template, values);
    normalizeRenderProps(renderProps);
    if (hooksRequired)
        addRenderHooks(renderProps);

    return renderProps;

};

function normalizeRenderProps(props) {

    if (!props)
        return;

    props.disabled = (props.disabled && 'disabled') || null;
    props.readonly = (props.readonly && 'readonly') || null;

};

function addRenderHooks(props) {

    if (!(props.disabled || props.readonly) && props['data-focus'] == 'auto') {
        props._hooks = {
            didInsert: function (node) {
                node.el.focus();
            }
        };
    }


};

// #endregion

export {

    defineElement as el,
    tag,

    grid,
    hrow,
    hrow as row,
    vrow,
    cell,
    autocell,

    hstrip,
    hstrip as strip,
    vstrip,
    slice,

    div,
    p,
    span,
    link,
    space,
    br,
    hr,
    img,
    d1,
    d2,
    d3,
    h1,
    h2,
    h3,

    list,

    table,
    thead,
    tbody,
    tfoot,
    trow,
    tcell,
    thcell,

    ulist,
    olist,
    litem,

    tabs,
    tab,

    labeledControl,

    app,
    main,
    header,
    footer,
    module,
    section,
    container,
    panel,
    overlay,
    dialog,

    card,
    cardHead,
    cardImg,
    cardTitle,
    cardBody,
    cardFoot,

    getCursorStyle,

    icon,
    hintIcon,

    group,
    group as formGroup,

    customButton,
    button,
    textButton,
    iconButton,
    expandButton,
    uploadButton,
    buttonArray,

    label,
    textBox,
    textArea,
    textAreaEx,
    numBox,
    checkBox,
    radioBox,
    comboBox,
    field,
    inputHint,
    inputError,

    menu,
    dropdownMenu,
    menuItem,
    menuDivider,
    dropdownButton,
    nav,
    navgap,
    navbar,
    navbarSection,
    navbarBrand,

    paginatorOffset,
    paginatorLimit,

    toast,
    empty,

    iframe,

    breadcrumbs,

    concat as concat,

    width,
    width as w,
    widthFixed,
    widthFixed as wf,

    cellWidth,
    cellWidth as cw,
    cellWidthFixed,
    cellWidthFixed as cwf,

    createRenderProps,
    normalizeRenderProps,
    addRenderHooks,


}
